<template>
    <div class="content">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询条件</span>
            </div>
            <div class="box-cont">
                <el-form :model="queryParams" ref="queryForm" :inline="true">
                    <el-form-item label="任务名称:" prop="taskName">
                        <el-input
                        v-model="queryParams.taskName"
                        placeholder="请输入任务名称"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item>
                    <el-form-item label="领取人:" prop="receiveName">
                        <el-select v-model="queryParams.receiveName" placeholder="请选择领取人" size="small" style="width:120px;">
                            <el-option
                                v-for="dict in userOptions"
                                :key="dict.dm"
                                
                                :label="dict.xm"
                                :value="dict.xm"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="领取日期:" >
                        <el-date-picker size="small" clearable
                            v-model="queryParams.startTime"
                            type="date"
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                        至
                        <el-date-picker size="small" clearable
                            v-model="queryParams.endTime"
                            type="date"
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button>
                        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询结果</span>
            </div>
            <div class="box-cont">
                <el-table v-loading="loading" :data="rwzxList">
                    <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="60">
                        <template slot-scope="scope">
                            <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="任务名称" prop="title" />
                    <el-table-column label="任务描述" prop="taskDescribe" />
                    <el-table-column label="领取人" align="center" prop="receiveName" />
                    <el-table-column label="领取截止时间" prop="deadlineReceiveTime"  >
                        <template slot-scope="scope">
                            <span v-if="scope.row.deadlineReceiveTime">{{getDate(scope.row.deadlineReceiveTime,'yyyy-MM-dd')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="上传截止时间" prop="deadlineUploadTime"  >
                        <template slot-scope="scope">
                            <span v-if="scope.row.deadlineUploadTime">{{getDate(scope.row.deadlineUploadTime,'yyyy-MM-dd')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="任务状态" align="center" class-name="small-padding fixed-width" width="80" >
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.type == 0"  size="small" type="info">待发布</el-tag>
                            <el-tag v-else-if="scope.row.type == 1"  size="small" type="warning">已发布</el-tag>
                            <el-tag v-else-if="scope.row.type == 2"  size="small" type="primary">已领取</el-tag>
                            <el-tag v-else-if="scope.row.type == 3"  size="small" type="danger">已上传</el-tag>
                            <el-tag v-else size="small" type="success">已评查</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="备注" prop="remark" >
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.remark" placement="bottom-start">
                                <span class="table-remark" style="display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ scope.row.remark }}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="140" >
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.type == 3"
                                size="small"
                                type="text"
                                @click="handleScxq(scope.row.id)"
                            >上传详情</el-button>
                            <el-button v-if="scope.row.type == 1"
                            size="small"
                            type="text"
                            @click="handleAddRw(scope.row.id)"
                        >领取</el-button>
                        <el-button v-if="scope.row.type != 0 && scope.row.type != 1"
                            size="small"
                            type="text"
                            @click="handleUpload(scope.row.recId)"
                        >上传</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-part" style="padding:20px 20px 50px;">
                    <el-pagination  v-if="pageshow"
                        background
                        @size-change='handleSizeChange'
                        @current-change='handleCurrentChange'
                        :current-page="queryParams.page"
                        :page-sizes="[10,20,30,40]"
                        :page-size="queryParams.limit"
                        layout="total, prev, pager, next, jumper"
                        :total="total" style=" float:right;">
                    </el-pagination>
                </div>
            </div>
        </el-card>
        <el-dialog title="上传案卷" :visible.sync="open" top="20vh" width="600px" append-to-body :close-on-click-modal="false" class="newTk">
            <div class="nr" v-loading="loading2">
                <el-form ref="form" :model="form" label-width="100px" class="shangchuan">
                    <el-form-item label="案卷:">
                        <el-upload
                            class="upload-demo"
                            drag              :before-remove="handleRemove"          
                            action="#"  :before-upload="beforeUpload"
                             :file-list="fileList"  :limit="1" :on-exceed="handleExceed">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <div class="el-upload__tip" slot="tip">仅支持pdf格式文件<br/>说明：扫描件300dpi以下，仅支持竖版</div>
                        </el-upload>
                        <p style="color: #ff0000;">{{errText}}</p>
                    </el-form-item>
                </el-form>
                <!-- <div slot="footer" class="dialog-footer" style="text-align:right;">
                    <el-button @click="open = false">取消</el-button>
                    <el-button type="primary" @click="pingcha">评查</el-button>
                </div> -->
            </div>
        </el-dialog>
        <el-dialog title="案中评查解析" :visible.sync="open2" top="8vh" width="85%" append-to-body class="newTk" :close-on-click-modal="false">
            <div class="nr">
                <p class="beizhu">注:系统智能识别后，部分文书未能智能识别，需进行人工识别。</p>
                <div class="cay" style="float:right;text-align: right;margin-top:-20px;" >
                    <!-- <el-button type="success" size="small" @click="getPingcha(row)">评查</el-button> -->
                </div>
                <div class="shibieW">
                    <div class="imgs left2">
                        <div class="imgW" v-loading="loading3">
                            <el-scrollbar ref="myScrollbar">
                                <p v-show="sbSrcs" v-for="(item,index) in sbSrcs" :key="index">
                                    <img :src="item.httpsUrl" @dblclick="showBig(item.httpsUrl)" />
                                    <span>第&nbsp;{{index + 1}}&nbsp;页</span>
                                </p>
                            </el-scrollbar>
                        </div>
                    </div>
                    <div class="right2">
                        <h3 style="    padding: 10px 0;">解析描述</h3>
                        <div style="    height: calc(100% - 40px);">
                            <el-form v-loading="loading4" ref="form" :model="form" label-width="0" style="height:100%;">
                                <el-form-item label="">
                                    <el-input type="textarea" v-model="jxnr" style="height:calc(67vh - 40px);"></el-input> 
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    
                </div>
                <div class="btns" style=" text-align:right;padding-top: 20px;">
                    <el-button size="small" @click="open2 = false">取消</el-button>
                </div>
            </div>
        </el-dialog>

        <div v-show="loading5"  style="z-index: 9000; position: fixed;background: rgba(0,0,0,0.05); top: 0; right: 0; bottom: 0; left: 0; overflow: auto;  margin: 0;">
            <div class="load" style="position: absolute;padding-top: 40px; z-index: 2;    background: linear-gradient(128deg, rgb(255, 255, 255) 40%, rgb(230, 240, 252)); width: 700px; height: 400px; border-radius: 4px; top: 18vh; left: 50%;  margin-left: -350px;  text-align: center;">
                <img style="margin: 30px auto 30px;" src="../../../assets/images/loading.png" />
                <p style="font-weight: bold; font-size: 18px;">案卷正在评查，预计需要1~5分钟,请不要关闭页面...</p>
            </div>
        </div>
        <el-dialog title="上传详情" :visible.sync="open4" width="80%" top="5vh" append-to-body class="newTk" :close-on-click-modal="false" style="min-height: 500px;">
            <!--<el-form :model="queryParams4" ref="queryForm4" :inline="true">
                <el-form-item label="地区:" prop="xianqu">
                    <el-select size="small" clearable v-model="queryParams4.xianqu">
                        <el-option v-for="(item,index) in xianquOptions" :key="index" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="任务名称:" prop="title">
                    <el-input
                    v-model="queryParams4.title"
                    placeholder="请输入任务名称"
                    clearable
                    size="small"
                    @keyup.enter.native="handleQuery"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery4">查询</el-button>
                    <el-button icon="el-icon-refresh" size="small" @click="resetQuery4">重置</el-button>
                </el-form-item>
            </el-form>-->
            <el-table v-loading="loadingSc" :data="scxqList">
                <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="60">
                    <template slot-scope="scope">
                        <span>{{(scope.$index+1) + ( queryParams4.limit * (queryParams4.page-1))}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="任务名称"  align="center" prop="title" width="160" />
                <el-table-column label="上传时间"  align="center" prop="createTime" width="100" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.createTime">{{getDate(scope.row.createTime,'yyyy-MM-dd')}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="测评状态" align="center" prop="assessStatusName" width="80" >
                    <template slot-scope="scope">
                        <el-tag  size="small" :type="scope.row.assessStatus == '1'?'success':'info'">{{scope.row.assessStatusName}}</el-tag>
                    </template>
                </el-table-column> 
                <el-table-column label="得分" align="center" prop="score" width="80" />
                <el-table-column label="被处罚名称" align="center" prop="punishedPerson" width="160"  />
                <el-table-column label="案由" prop="causeOfAction" />
                <el-table-column align="center" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" v-if="scope.row.assessStatus == '1'" @click="getPcImg(scope.row.id)">评查详情</el-button>
                        <el-button size="mini" type="text" @click="handlePcaj(scope.row.id)">查看案卷</el-button>
                        <el-button size="mini" type="text" @click="handlePc(scope.row)">评查</el-button>
                    </template> 
                </el-table-column>
            </el-table>
            <div class="page-part" style="padding:20px 20px 50px;">
                <el-pagination  v-if="pageshow4"
                    background
                    @size-change='handleSizeChange4'
                    @current-change='handleCurrentChange4'
                    :current-page="queryParams4.page"
                    :page-sizes="[10,20,30,40]"
                    :page-size="queryParams4.limit"
                    layout="total, prev, pager, next, jumper"
                    :total="total4" style=" float:right;">
                </el-pagination>
            </div>
        </el-dialog>

        <el-dialog title="评查详情" :visible.sync="open5" width="80%" top="5vh" append-to-body class="newTk" :close-on-click-modal="false" style="min-height: 500px;">
            <h3 style="display: flex; align-items: center;margin-bottom:5px;"><span style="width:67px;text-align: justify; text-align-last: justify;">评查得分</span>：{{pcdf}}</h3>
            <h3 style="display: flex; align-items: center;margin-bottom:5px;"><span style="width:67px;text-align: justify; text-align-last: justify;">违法程度</span>：{{wfcd}}</h3>
            <h3 style="display: flex; align-items: center;margin-bottom:5px;"><span style="width:67px;text-align: justify; text-align-last: justify;">案  由</span>：{{anyou}}</h3>
            <el-table v-loading="loadingSc" :data="pcjgList">
                <el-table-column align="center" label="序号" type="index" width="60" />                
                <el-table-column align="center" label="评查指标" prop="name" />
                <el-table-column align="center" label="是否合格" prop="correct" width="80" >
                    <template slot-scope="scope">
                        <el-tag size="small" :type="(scope.row.correct === 'true') ? 'success' : 'danger'">
                            {{ (scope.row.correct === 'true') ? "合格" : "不合格" }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="审核描述" prop="describe"  />
                <el-table-column align="center" label="扣分" prop="fz" width="60" />
                <el-table-column align="center" label="评查人" prop="dmName" width="80" />
                <el-table-column align="center" label="审核人" prop="updateName" width="80" />
                <el-table-column align="center" label="审核时间" prop="updateTime"  width="120" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.updateTime">{{getDate(scope.row.updateTime,'yyyy-MM-dd')}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="审核状态" prop="status" width="80" >
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 1"  size="small" type="warning">审核中</el-tag>
                        <el-tag v-else-if="scope.row.status == 2"  size="small" type="success">已通过</el-tag>
                        <el-tag v-else-if="scope.row.status == 3"  size="small" type="danger" @click="getRemark(scope.row.remark)">已驳回</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status != 1" size="mini" type="text" @click="getPcUpdate(scope.row)">修改</el-button>
                    </template> 
                </el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog title="查看案卷" :visible.sync="open6" width="600px" top="5vh" append-to-body class="newTk" :close-on-click-modal="false" style="min-height: 500px;">
            
            <div class="anjuan" v-loading="loadingAj">
                <!--<h3>{{ajbt}}</h3><div class="menus">
                    <el-scrollbar ref="myScrollbar">
                        <ul>
                            <li v-for="(item,index) in ajNames" :key="index" :class="isIndex == index?'active':''" @click="showWs(item,index)">
                                <p><i class="el-icon-document"></i>&nbsp;{{ item.name }}</p>
                            </li>
                        </ul>
                    </el-scrollbar>
                </div>-->
                <div class="imgW">
                    <el-scrollbar ref="myScrollbar2">
                        <p v-show="ajImgs" v-for="(item,index) in ajImgs" :key="index">
                            <img :src="item" @dblclick="showBig(item)" />
                        </p>
                        <!--<el-button type="text" size="small" v-show="ajImgs[isIndex]" @click="showText(1)" style="position: absolute; top: 15px; left: 10px;box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);">相关参数</el-button>-->
                    </el-scrollbar>
                </div>
            </div>
        </el-dialog>

        <el-dialog title="案卷文书" :visible.sync="openBig" top="20px" :width="isH?'700px':'1200px'" append-to-body ref="rotate"  :close-on-click-modal="false">
            <div style="text-align: right; margin-right: 40px; position: absolute; right: 10px; top: 8px;"><el-button type="warning" size="small" @click="rotate">旋转</el-button></div>
            <!--<p v-show="bigSrcs" v-for="(item,index) in bigSrcs" :key="index" :style="{'width':isH?'100%':'70%'}" style="margin: 0px auto;">
                <img :src="item" style="width: 100%;" />
            </p>-->
            <p v-show="bigSrc" ref="rotate" :style="{'width':isH?'100%':'70%'}" style="margin: 0px auto;"><img :src="bigSrc"  style="width: 100%;" /></p>
        </el-dialog>


        <el-dialog title="修改评查内容" :visible.sync="open7" width="800px" append-to-body class="newTk" :close-on-click-modal="false">
            <el-form ref="pcForm" :model="pcForm" :rules="rulesPc" label-width="100px">
                <el-form-item label="评查指标" prop="name">
                    <el-input v-model="pcForm.name" size="small" disabled></el-input>
                </el-form-item>
                <el-form-item label="是否合格" prop="correct">
                    <el-radio-group size="small" v-model="pcForm.correct">
                        <el-radio label="true">合格</el-radio>
                        <el-radio label="false">不合格</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="审核描述" prop="describe">
                    <el-input size="small" v-model="pcForm.describe" type="textarea" :rows="5"></el-input>
                </el-form-item>
                <el-form-item label="扣分" prop="fz">
                    <el-input size="small" v-model="pcForm.fz" type="number" min="0"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary"  size="small" @click="submitPcUpdate('pcForm')">确 定</el-button>
                <el-button size="small" @click="open7 = false">取 消</el-button>
            </div>
        </el-dialog>
   

    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            queryParams:{
                taskName: '',
                receiveName: '',
                startTime: '',
                endTime: '',
                page:1,
                limit:10,
            },
            total:0,
            rwzxList:[],
            userOptions:[],
            ztOptions:[],
            open:false,
            pageshow:true,
            cmid:'',
            sc: "",
            xg: "",
            xz: "",
            open:false,
            fileList: [],
            files: null,
            fileName: '',
            errText:'',
            dm: '',
            rwId:'',
            open2:false,
            jxnr:'',
            loading2:false,
            loading3:false,
            sbSrcs:'',
            loading4:false,
            form:{},
            recId:'',
            open4:false,
            loadingSc:false,
            scxqList:[],
            queryParams4:{
                page:1,
                limit:10
            },
            total4:0,
            pageshow4:true,
            xqId:'',
            loading5:false,
            open5:false,
            pcdf: 0,
            wfcd:'',
            anyou:'',
            zfs: 0,
            pcjgList:[],
            open6:false,
            ajbt:'',
            ajNames:[],
            ajImgs:[],
            isIndex:0,
            loadingAj: false,
            openBig: false,
            bigSrc: '',
            isH: false,
            deg:0,
            pcForm:{},
            rulesPc:{
                correct:[{ required: true, message: '请选择审核状态', trigger: 'change' }],
                describe:[{ required: true, message: '请填写审核描述', trigger: 'blur' }],
                fz:[{ required: true, message: '请输入扣分', trigger: 'blur' }]
            },
            open7:false,
            pcXqId:'',
            baseUrl:''
        }
    },
    components: {
    },
    computed: {
    },
    created() {
    },
    async mounted() {
        let quxian = JSON.parse(sessionStorage.getItem("quxiandata"));
        console.log(quxian)
        if(quxian && quxian.length > 0){
            quxian.forEach(ele=> {
                if(ele.item == '一般程序处罚案件列表'){
                    this.sc = ele.sc
                    this.xg = ele.xg
                    this.xz = ele.xz
                }
            })
        }
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.cmid = user.c_mid
        this.dm = user.dm
        this.baseUrl = user.baseUrl
        axios({
            method: 'post',
            url: `https://xxswj.hzxhykj.com:9086/xx/lawEnforcer`,
            headers: { // 添加请求头
                "Content-Type": "application/json" // 明确声明为 JSON 格式
            },
            data: {
                cmid:this.cmid
            }
        })
        .then(response => {
            this.userOptions = response.data.data
        })
        .catch(error => {
            this.$message.error('获取监督员数据失败！');
            console.error('There was an error!', error);
        });
        this.getList()
    },
    methods: {
        getRemark(remark){
            console.log(remark,449)
            this.$alert(remark,'驳回原因',  {
                confirmButtonText: '',
                callback: action => {
                    this.$message({
                    type: 'info',
                    message: ''
                    });
                }
            });
        },
        async getList(){
            this.rwzxList = []
            this.total = 0
            
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/receiveList`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    dm:this.dm,
                    cmid:this.cmid,
                    taskName:this.queryParams.taskName,
                    receiveName:this.queryParams.receiveName,
                    startTime:this.queryParams.startTime,
                    endTime:this.queryParams.endTime,
                    pageSize:this.queryParams.limit,
                    pageNum:this.queryParams.page
                }
            })
            .then(response => {
                console.log(response.data);
                this.rwzxList = response.data.data.list
                this.total = response.data.data.total || 0
                this.loading = false
            })
            .catch(error => {
                this.loading = false
                this.$message.error('获取数据失败！');
                console.error('There was an error!', error);
            });
        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        beforeUpload(file){
            this.fileList = []
            this.files = file;
            const extension = file.name.split('.')[1] === 'pdf'
            // const isLt2M = file.size / 1024 / 1024 < 5
            if (!extension) {
            this.$message.warning('上传模板只能是 pdf格式!')
            return
            }
            // if (!isLt2M) {
            // this.$message.warning('上传模板大小不能超过 5MB!')
            // return
            // }
            this.fileList.push({name:file.name})
            // 防止添加超过一个文件
            //if (this.fileList.length >= 1) {
            //    this.$message.warning('只能上传一个文件，请先删除已上传的文件再尝试上传新文件。');
            //    return false;
            //} 

            this.fileName = file.name;

            this.submitAj()
            return false // 返回false不会自动上传
        }, 
        handleRemove(file, fileList) {
            if(file.status == 'success'){
                if(this.fileList.length > 1){
                    let isy = this.fileList.findIndex(item => {
                        return item.name == file.name
                    })
                    if(isy != -1){
                        this.fileList.splice(isy,1) 
                    }
                }
            }
        },
        handleExceed(files, fileList) {
            this.$message.warning('只能上传一个文件，请先删除已上传的文件再尝试上传新文件。');
        },
        async submitAj(){
            this.loading2 = true
            if(this.fileName == ""){
                this.$message.warning('请选择要上传的文件！')
                return false
            }
            let fileFormData = new FormData();
            fileFormData.append('files', this.files);//filename是键，file是值，就是要传的文件，test.zip是要传的文件名
            fileFormData.append('id', this.recId);
            
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/upload`,
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                data:fileFormData
            })
            .then(res => {
                console.log(res)
                this.loading2 = false;
                if(res.data.code == 0){
                    this.$message.success('案卷上传成功！')
                    this.fileUrl = res.data.data.fileUrl
                    console.log(this.fileUrl,125)
                    this.open = false
                    this.getList()
                }else{
                    this.$message({
                        message: res.data.msg ? res.data.msg : '上传PDF文件失败，请重试！',
                        duration: 5000,
                        type: 'error'
                    });
                    this.fileList = [],
                    this.files = '',
                    this.fileName = '',
                    this.fileUrl =''
                }
            })
            .catch(error => {
                this.fileList = [],
                this.files = '',
                this.fileName = '',
                this.fileUrl =''
                this.loading2 = false
                this.$message({
                    message: error.data.msg ? error.data.msg : '上传PDF文件失败，请重试！',
                    duration: 5000,
                    type: 'error'
                });
            });
		},
        pingcha(){
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/process/anZhongFileOcr`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    cmid: this.cmid,
                    type: 2,
                    file: this.files,
                    imageList : [],
                    
                }
            })
            .then(res => {
                console.log(res)
                if(res.data.code == 0){
                    this.pcId = res.data.data.pcId
                    this.pdfUrl = res.data.data.pdfUrl
                    console.log(this.pcId,546)
                    this.$message.success('评查成功！')
                    this.getList()
                }else{
                    this.open2 = false
                }
            })
            .catch(error => {
                this.open2 = false
                this.$message({
                    message: error.data.msg ? error.data.msg : '加载失败，请重试！',
                    duration: 5000,
                    type: 'error'
                });
            });
        },
        handleAddRw(id){
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/addReceive`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    dm:this.dm,
                    cmid:this.cmid,
                    releaseId:id
                }
            })
            .then(res => {
                console.log(res,244)
                this.loading = false
                if(res.data.code == 0){
                    this.$message.success('领取成功！');
                    this.getList()
                }else{
                    this.$message.error(res.data.msg || '发布失败，请联系管理员！');
                }
            })
            .catch(error => {
                this.$message({
                    message: error.data.msg ? error.data.msg : '发布失败，请联系管理员！',
                    duration: 5000,
                    type: 'error'
                });
            });
        },
        handleUpload(recId){
            this.open = true
            this.recId = recId
            console.log(this.recId,recId)
            this.fileList = [],
            this.files = '',
            this.fileName = '',
            this.fileUrl =''
        },
        resetQuery(){
            this.queryParams = {
                taskName: '',
                receiveName: '',
                startTime: '',
                endTime: '',
                page:1,
                limit:10,
            }
            this.getList()
        },
        handleSizeChange4(val){
            this.queryParams4.limit = val
            this.getXq(this.xqId)
        },
        handleCurrentChange4(val){
            this.pageshow4 = false;
            this.queryParams4.page = val
            this.getXq(this.xqId)
            this.$nextTick(() => {
                this.pageshow4 = true;
            });
        },
        handleQuery4(){
            this.pageshow4 = false;
            this.queryParams4.page = 1
            this.getXq(this.xqId)
            this.$nextTick(() => {
                this.pageshow4 = true;
            });
        },
        resetQuery4(){
            this.queryParams4 = {
                page:1,
                limit:10,
            }
            this.getXq(this.xqId)
        },
        handleScxq(id){
            this.xqId = id
            this.queryParams4 = {
                page:1,
                limit:10,
            }
            this.scxqList = []
            this.total4 = 0
            this.open4 = true
            this.getXq(id)
        },
        getXq(id){ 
            this.loadingSc = true
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/detailsReceive`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id: id,
                    cmid: this.cmid,
                    pageSize:this.queryParams4.limit,
                    pageNum:this.queryParams4.page
                }
            })
            .then(response => {
                console.log(response);
                this.scxqList = response.data.data.list
                this.total4 = response.data.data.total
                this.loadingSc = false
            })
            .catch(error => {
                this.loadingSc = false
                console.error('There was an error!', error);
            });
        },
        handlePc(row){
            this.loading5 = true
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/taskEvaluation`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id: row.id,
                }
            })
            .then(response => {
                console.log(response,686);
                if(response.data.code == 0 ){
                    this.getPcImg(row.id)
                    this.getXq(this.xqId)
                    this.loading5 = false
                }else{
                    this.$message.error(response.data.msg ? response.data.msg : '加载失败，请重试！')
                }
                //this.pcsrc = response.data.data
                this.loading5 = false
            })
            .catch(error => {
                this.loading5 = false
                console.error('There was an error!', error);
            });
        },
        getPcImg(id){ 
            this.pcXqId = id
            this.pcjgList = []
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/evaluationResult`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id: id,
                }
            })
            .then(response => {
                console.log(response,686);
                if(response.data.code == 0 ){
                    this.open5 =  true
                    this.pcjgList = response.data.data.evaluationResultResList
                    this.pcdf = response.data.data.sumFz || 0
                    this.wfcd = response.data.data.wfcd || ''
                    this.anyou = response.data.data.anyou || ''
                }else{
                    this.$message.error(response.data.msg ? response.data.msg : '加载失败，请重试！')
                }
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        },
        handleClose6(){
            this.open6 = false
            this.ajImgs = []
            this.bigSrc = ''
            this.isH = true
            this.$refs.rotate.style.transform = `rotate(0deg)`
            this.loadingAj = false
            this.pcsrc = ''
            this.xqId = ''
            this.scxqList = []
            this.total4 = 0
            this.queryParams4
        },
        handlePcaj(id){
            this.open6 = true
            this.loadingAj = true
            this.ajImgs = []
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/viewCaseFile`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id: id,
                }
            })
            .then(response => {
                console.log(response,686);
                if(response.data.code == 0 ){
                    this.ajImgs = response.data.data.imgList
                }else{
                    this.$message.error(response.data.msg ? response.data.msg : '加载失败，请重试！')
                }
                this.loadingAj = false
            })
            .catch(error => {
                this.loadingAj = false
                console.error('There was an error!', error);
            });
        },
        showBig(src){
            this.bigSrc = src
            this.openBig = true
            this.isH = true
            this.$refs.rotate.style.transform = `rotate(0deg)`
        },
        // 旋转图片
        rotate () {
            this.isH = false
            this.deg += 90
            if (this.deg >= 360) {
                this.deg = 0
            }
            this.$refs.rotate.style.transform = `rotate(${this.deg}deg)`
        },
        //修改评查内容
        getPcUpdate(row){
            this.pcForm = row
            this.open7 = true
        },
        submitPcUpdate(pcForm){
            this.$refs[pcForm].validate((valid) => {
                if (valid) {
                    console.log(this.pcForm,864)
                    axios({
                        method: 'post',
                        url: `https://xxswj.hzxhykj.com:9086/system/release/evaluationUpdate`,
                        headers: { // 添加请求头
                            "Content-Type": "application/json" // 明确声明为 JSON 格式
                        },
                        data: {
                            id: this.pcForm.id,
                            correct:this.pcForm.correct,
                            describe:this.pcForm.describe,
                            fz:this.pcForm.fz,
                            dm:this.dm
                        }
                    })
                    .then(response => {
                        console.log(response);
                        this.getPcImg(this.pcXqId)
                        this.open7 = false
                    })
                    .catch(error => {
                        this.open7 = false
                        console.error('There was an error!', error);
                    });
                }
            })
        }
    }
}
</script>


<style scoped>
.anjuan{ width:100%; overflow:hidden; height:80vh;}
.menus{ width: 200px;  height: calc(100% - 45px); float: left;}
.anjuan >>> .el-scrollbar { width: 100%; height: 100%;}
.anjuan >>> .el-scrollbar__bar.is-horizontal{opacity: 0;}
.anjuan >>> .el-scrollbar__wrap { overflow-y: auto !important; overflow-x: hidden;}
.anjuan >>> .el-scrollbar__view{min-height: 100%;}
.anjuan .imgW >>> .el-scrollbar__view{ background: #eef3f9;}
.anjuan h3{background: #fff; width:100%; color:#000; border-bottom: solid 1px #ddd; line-height: 36px; margin-bottom: 8px;}
.anjuan ul{width: 180px;margin-right: 10px;padding-bottom: 10px}
.anjuan ul li{line-height: 36px; width: 100%; overflow: hidden; white-space: normal; text-overflow: ellipsis; cursor: pointer;}
.anjuan ul li.active{color:#1890ff;}
.imgW{width: 100%;  height: calc(100% - 45px);float: right;}
.imgW img{ width: 100%;}
.imgW h3{border-bottom: none; padding:10px 0;}
.imgW h3 span{ border-left: solid 4px #1890ff; line-height: 1; padding-left: 6px;display: block;}
.imgW >>> .el-form{ padding: 10px 0 10px 10px; width: calc(100% - 45px);}
.bigimg{width: 100%;}
</style>